import {History} from "stateshot";
// import FJEvent from "../core/FJEvent";
import FJEventConstant from "../constant/FJEventConstant";

let FJUndoStore = (function () {

  let _history = null;
  let _state = {};
  return {

    /**
     * @description 初始化
     * @param initState
     */
    init: function (initState) {
      _history = new History({
        initState: _state,
        maxLength: 50,
        rules: [
          {
            match: function (nodeSate) {
              return Object.prototype.toString.call(nodeSate) === '[object Object]';
            },
            fromRecord: function ({ chunks }) {
              let state = {};
              chunks.forEach(chunk => {
                state = {
                  ...state,
                  ...chunk,
                }
              });
              return state;
            },
            toRecord: function (nodeSate) {
              let chunks = [];
              for (let key in nodeSate) {
                if (nodeSate.hasOwnProperty(key)) {
                  let chunk = {};
                  chunk[key] = nodeSate[key];
                  chunks.push(chunk);
                }
              }
              return { chunks }
            },
          }
        ],
      });
      _history.pushSync(Object.assign(_state, initState));
    },

    /**
     * @description 添加undo数据
     * @param state
     */
    pushSync: function (state, graphId) {
      if (_history) {
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS_BEFORE);
        _history.pushSync(Object.assign(_state, {...state, graphId}));
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS);
      }
    },

    /**
     * @description 返回当前数据
     * @return {*}
     */
    get: function () {
      if (_history) {
        let state = _history.get() || {};
        let pureState = JSON.parse(JSON.stringify(state));
        let graphId = pureState.graphId;

        // graphId是用来标记当前操作的对象，decode时删除
        delete pureState.graphId;

        return {
          graphId,
          state: pureState,
        };
      }
    },

    /**
     * @description undo
     * @return {undefined|History}
     */
    undo: function () {
      if (_history) {
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS_BEFORE);
        _history.undo();
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS);
        return _history
      }
    },

    /**
     * @description redo
     * @return {undefined|History}
     */
    redo: function () {
      if (_history) {
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS_BEFORE);
        _history.redo();
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS);
        return _history;
      }
    },

    /**
     * @description 是否能undo
     * @return {FJUndoStore.hasUndo|boolean}
     */
    hasUndo: function () {
      if (_history) {
        return _history.hasUndo;
      }
    },

    /**
     * @description 是否能redo
     * @return {FJUndoStore.hasRedo|boolean}
     */
    hasRedo: function () {
      if (_history) {
        return _history.hasRedo;
      }
    },

    /**
     * @description 清除undo栈
     */
    clear: function () {
      if (_history) {
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS_BEFORE);
        _history.reset();
        window.FJEvent.dispatch(FJEventConstant.CHANGE_UNDO_REDO_STATUS);
      }
    },
  }
})();

export default FJUndoStore;
